module.exports = __webpack_public_path__ + "img/2-4.d8b8de74.png";